<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body,html,#app {
    height: 100%;
    overflow: hidden;
  }
  @page {
    size: auto; /* auto is the initial value */
    margin: 3mm; /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue